import type { PlayerAction } from '@frontend/core'

/**
 * Check if action was successful based on outcomes.
 *
 * The API has two conventions: older actions use a boolean `success` field,
 * newer actions use an `outcomes` array with string values. We check both,
 * preferring the explicit boolean when present.
 *
 * The success set matches the Angular tool's action-translations.ts.
 */
export function isActionSuccessful(action: PlayerAction): boolean {
  if (action.success != null) return action.success
  if (!action.outcomes?.length) return false
  const successOutcomes = new Set(['Goal', 'Complete', 'Retained', 'Touchdown'])
  return action.outcomes.some((o) => successOutcomes.has(o))
}

/**
 * Check if action has vector coordinates (start + end position).
 * Vector actions render as arrows on the pitch, point-only actions as circles.
 */
export function isVectorAction(
  action: PlayerAction
): action is PlayerAction & { endX: number; endY: number } {
  return action.endX != null && action.endY != null
}
